<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CCard class="p-4">
      <CCardBody>
        <CForm>
          <h1>Login</h1>
          <p class="text-muted">Sign In to your account</p>
          <CInput placeholder="Username" autocomplete="username" v-model="name" autocapitalize=off>
            <template #prepend-content>
              <CIcon name="cil-user" />
            </template>
          </CInput>
          <CInput
            placeholder="Password"
            type="password"
            v-model="password"
            autocomplete="curent-password"
            v-on:keyup.enter="handleSubmit"
          >
            <template #prepend-content>
              <CIcon name="cil-lock-locked" />
            </template>
          </CInput>
          <CAlert show color="danger" v-if="isInvalidLogin">Neispravno ime i sifra</CAlert>
          <CRow>
            <CCol col="6" class="text-left">
              <CButton color="primary" class="px-4" @click="handleSubmit">Login</CButton>
            </CCol>
          </CRow>
        </CForm>
      </CCardBody>
    </CCard>
  </CContainer>
</template>

<script>
import Vue from "vue";
export default {
  name: "Login",
  data() {
    return {
      name: "",
      password: "",
      isInvalidLogin: ""
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      if (this.password.length > 0) {
        let self = this;
        Vue.http
          .post("api/user/login", {
            name: this.name,
            password: this.password
          })
          .then(response => {
            localStorage.setItem("jwt", response.data.token);

            this.$emit("loggedIn");
            if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl);
            } else {
              this.$router.push("/");
            }
          })
          .catch(function() {
            self.isInvalidLogin = true;
          });
      }
    }
  }
};
</script>
